import theme from "../../../style/theme";
import { createPolyline } from "./create-polyline";

export const createGrayPolyline = (
  map: naver.maps.Map,
  path: naver.maps.LatLng[]
) => {
  return createPolyline(map, theme.palette.primitives["gray300"], path);
};
